const is_numeric = (number) => {
    return !isNaN(parseFloat(number)) && isFinite(number);
};
const months = {
    'jan': 0,
    'feb': 1,
    'mar': 2,
    'apr': 3,
    'may': 4,
    'jun': 5,
    'jul': 6,
    'aug': 7,
    'sep': 8,
    'oct': 9,
    'nov': 10,
    'dec': 11
};
const days = {
    'su': 0,
    'mo': 1,
    'tu': 2,
    'we': 3,
    'th': 4,
    'fr': 5,
    'sa': 6
};
function dateDiffInDays(date1, date2) {
    // Convert both dates to UTC to ensure the calculation is based on the same time zone
    const utcDate1 = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
    const utcDate2 = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());
    // Calculate the time difference in milliseconds
    const timeDifference = utcDate2 - utcDate1;
    // Convert the time difference to days
    const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    return Math.abs(daysDifference);
}
export function isVisible(formData, conditionRule, conditions, conditionAction) {
    if ((conditions === null || conditions === void 0 ? void 0 : conditions.length) === 0)
        return true;
    let conditionsMet = 1;
    const sanitizedValue = (fieldId) => typeof formData[fieldId] === 'object' ? formData[fieldId] : (formData[fieldId] || '').toString().toLowerCase();
    const conditionRules = {
        'contains': (fieldId, value) => {
            const formValue = sanitizedValue(fieldId);
            return (formValue === null || formValue === void 0 ? void 0 : formValue.indexOf(value)) !== -1 ? true : false;
        },
        'is': (fieldId, value) => {
            const formValue = sanitizedValue(fieldId);
            if (typeof formValue === 'object') {
                return formValue.includes(value);
            }
            return formValue.toString() === value.toLowerCase();
        },
        'starts': (fieldId, value) => {
            const fromValue = sanitizedValue(fieldId);
            return fromValue.startsWith(value.toLowerCase());
        },
        "is_not": (fieldId, value) => {
            const formValue = sanitizedValue(fieldId);
            if (typeof formValue === 'object') {
                return !formValue.includes(value);
            }
            return formValue !== value.toLowerCase();
        },
        "is_great": (fieldId, value) => {
            const value1 = +formData[fieldId];
            const value2 = +value;
            return is_numeric(value1) && is_numeric(value2) ? value1 > value2 : false;
        },
        "is_less": (fieldId, value) => {
            const value1 = +formData[fieldId];
            const value2 = +value;
            return is_numeric(value1) && is_numeric(value2) ? value1 < value2 : false;
        },
        "ends": (fieldId, value) => {
            return sanitizedValue(fieldId).endsWith(value.toLowerCase());
        },
        "month_is": (fieldId, value) => {
            const date = new Date(formData[fieldId]);
            const monthIndex = date.getMonth();
            if (isNaN(monthIndex))
                return false;
            return months[value.toLowerCase()] === monthIndex;
        },
        "month_is_not": (fieldId, value) => {
            const date = new Date(formData[fieldId]);
            const monthIndex = date.getMonth();
            if (isNaN(monthIndex))
                return true;
            return months[value.toLowerCase()] !== monthIndex;
        },
        "day_is": (fieldId, value) => {
            const date = new Date(formData[fieldId]);
            const weekDayIndex = date.getDay();
            const valueIndex = days[value.toLowerCase()];
            return weekDayIndex === valueIndex;
        },
        "day_is_not": (fieldId, value) => {
            const date = new Date(formData[fieldId]);
            const weekDayIndex = date.getDay();
            const valueIndex = days[value.toLowerCase()];
            return weekDayIndex !== valueIndex;
        },
        "is_before": (fieldId, value) => {
            const date1 = new Date(formData[fieldId]);
            const date2 = new Date(value);
            return date1 < date2;
        },
        "is_after": (fieldId, value) => {
            const date1 = new Date(formData[fieldId]);
            const date2 = new Date(value);
            return date1 > date2;
        },
        "is_before_n_or_more_days": (fieldId, value) => {
            const date1 = new Date();
            const date2 = new Date(formData[fieldId]);
            const limit = +value;
            const diff = dateDiffInDays(date1, date2);
            return date1 > date2 && diff >= limit;
        },
        "is_before_less_than_n_days": (fieldId, value) => {
            const date1 = new Date();
            const date2 = new Date(formData[fieldId]);
            const limit = +value;
            const diff = dateDiffInDays(date1, date2);
            return date1 > date2 && diff <= limit;
        },
        "is_after_n_or_more_days": (fieldId, value) => {
            const date1 = new Date();
            const date2 = new Date(formData[fieldId]);
            const limit = +value;
            const diff = dateDiffInDays(date1, date2);
            return date1 < date2 && diff >= limit;
        },
        "is_after_less_than_n_days": (fieldId, value) => {
            const date1 = new Date();
            const date2 = new Date(formData[fieldId]);
            const limit = +value;
            const diff = dateDiffInDays(date1, date2);
            return date1 < date2 && diff <= limit;
        },
    };
    for (let index in conditions) {
        const condition = conditions[index];
        const { rule, element_id, value } = condition;
        try {
            const conditionFulfilled = conditionRules[rule](element_id, value);
            // if(conditionRule === 'all' && conditionFulfilled === false) return false;
            if (conditionRule === 'any' && conditionFulfilled === true)
                return conditionAction === 'hide' ? false : true;
            conditionsMet *= Number(conditionFulfilled);
        }
        catch (err) {
            console.warn(rule);
        }
    }
    return conditionAction === 'hide' ? !Boolean(conditionsMet) : Boolean(conditionsMet);
}
